exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-blanco[data-v-2bc41386]{padding-bottom:50px}.card-row[data-v-2bc41386]{margin-bottom:20px}.button.is-dark:hover .button.is-dark.is-hovered[data-v-2bc41386]{background-color:#3273dc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bc41386","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/estaciones_Componentes/Reportes.vue
// module id = 2806
// module chunks = 0